import {createContext, ReactElement, ReactNode, useState} from "react";
import {useParams} from "react-router-dom";

import {getFournisseur as fetchFournisseur} from "@/Api/fournisseur";
import {useGetContext} from "@/hooks/useGetContext/useGetContext";
import {
  useLoadingState,
  UseLoadingStateReturn,
} from "@/hooks/useLoadingState/useLoadingState";
import {AppContext as AppContextType} from "@/ts/appContext";
import {FournisseurAndCampagne} from "@/ts/fournisseur";

import {AppContext} from "./AppContext";
import {UserParamContext, UserParamContextType} from "./UserParamContext";

export interface FournisseurContextType {
  fournisseurAndCampagne: FournisseurAndCampagne | undefined;
  fournisseurAndCampagneLoadingState: UseLoadingStateReturn;
  setFournisseurAndCampagne: (
    fournisseurAndCampagne: FournisseurAndCampagne
  ) => void;
  getFournisseur: () => Promise<void>;
}

export const FournisseurContext = createContext<FournisseurContextType | null>(
  null
);

// ce contexte est utilisé pour récupérer les données du fournisseur et la campagne
// il sert uniquement pour la page Fournisseur/:fournisseur_id

export function FournisseurContextProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [fournisseurAndCampagne, setFournisseurAndCampagne] = useState<
    FournisseurAndCampagne | undefined
  >(undefined);
  const fournisseurAndCampagneLoadingState = useLoadingState();

  const {currentCampagne, currentContremarque = undefined} =
    useGetContext<UserParamContextType>(UserParamContext, "UserParamContext");

  const {id} = useParams();
  const {API} = useGetContext<AppContextType>(AppContext, "AppContext");

  const getFournisseur = async (): Promise<void> => {
    const reponse =
      await fournisseurAndCampagneLoadingState.executeWithLoading<FournisseurAndCampagne>(
        () =>
          fetchFournisseur(
            API,
            Number(id),
            currentCampagne.value,
            currentContremarque?.value
          )
      );

    setFournisseurAndCampagne(reponse);
  };
  return (
    <FournisseurContext.Provider
      value={{
        fournisseurAndCampagneLoadingState,
        fournisseurAndCampagne,
        setFournisseurAndCampagne,
        getFournisseur,
      }}>
      {children}
    </FournisseurContext.Provider>
  );
}
